





















































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    formatDate,
    getCurrentTime
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
} from '../../core/components';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { JourneysService } from '../api/JourneysService';
import { dateTypes } from '../../core/models';
import SimpleTable from '../../core/components/SimpleTable.vue';
import { getOTStateText } from '../../journeys/utils';
import JourneyOTDetail from './JourneyOTDetail.vue';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SimpleTable,
        JourneyOTDetail
    }
})
export default class JourneyOTList extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    
    @Prop({ default: false }) pendingJourneyDetail: boolean;
    @Prop({ default(){ return [] }}) otsList: Array<object>;
    headers:Array<object> = [
        { text: 'Vehículo', value: 'vehicle.description', align: 'center' },
        { text: 'N° OT', value: 'number', align: 'center' },
        { 
            text: 'Hora Carga', 
            value: 'load_time', 
            align: 'center',
            width: '200px',
            formatter: (value: string) => {
                return formatDate(value, true)
            }
        },
        { 
            text: 'Origen', 
            value: 'detail.mount.value',
            align: 'center'
        },
        { 
            text: 'Destino', 
            value: 'detail.dest.value',
            align: 'center'
        },
        { 
            text: 'Situación', 
            value: 'detail.status.value',
            align: 'center'
        }
    ];
    visibleOTDetail: boolean = false;
    otDetail: object = {};
    otsStateIcon: object = {
        "Finalizada": "mdi-checkbox-marked-circle",
        "Generada": "mdi-file-document",
        "Cargado": "mdi-truck",
        "Aceptado": "mdi-checkbox-marked-circle"
    }

    otsStateColor: object = {
        "Finalizada": "success",
        "Generada": "primary",
        "Cargado": "info",
        "Aceptado": "primary",
    }

    getOtStateIcon = (ot: object) => {
        if(ot && ot['detail'] && ot['detail'].status && ot['detail'].status.value){
             return this.otsStateIcon[ot['detail'].status.value]
        }
        return ''
    }

    getOtStateColor = (ot: object) => {
        if(ot && ot['detail'] && ot['detail'].status && ot['detail'].status.value){
            return this.otsStateColor[ot['detail'].status.value]
        }
        return 'gray'
    }

    viewOtDetail(ot: object) {
        this.otDetail = ot;
        this.visibleOTDetail = true;
    }

    onRowClick(row: object) {
        this.viewOtDetail(row);
    }


    closeOtDetail() {
        this.visibleOTDetail = false;
    }

    mounted() {
        // this.$nextTick(() => {
            
        // });
    }
}
